var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
const HeadCell = styled.th `
  text-align: ${(props) => props.align};
  border-bottom: ${props => props.theme.utils.borderColor(props.theme.utils.getColor('main'))};
  color: inherit;
  ${(props) => props.stickyHeader &&
    css `
      background-color: white;
      top: 0;
      left: 0;
      z-index: 2;
      position: sticky;
    `};
`;
const RowCell = styled.td `
  border-bottom: ${props => props.theme.utils.borderColor(props.theme.utils.getColor('grey'))};
  text-align: ${(props) => props.align};
`;
const TableCell = (_a) => {
    var { align = 'left', scope = '', role = 'cell', stickyHeader = false, children } = _a, props = __rest(_a, ["align", "scope", "role", "stickyHeader", "children"]);
    return scope
        ? (_jsx(HeadCell, Object.assign({ stickyHeader: stickyHeader, align: align, scope: scope, role: role }, props, { children: children })))
        : (_jsx(RowCell, Object.assign({ align: align }, { children: children })));
};
export default TableCell;
